/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS, HttpInterceptor } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { MockHttpInterceptorService } from '@app/core/services/mock-http-interceptor.service';
import { HttpErrorEnhancerInterceptor } from './http-error-enhancer-interceptor';
import { HydraSystemHttpInterceptor } from './hydra-system-interceptor';
import { PortalVersionHttpInterceptor } from './portal-version-interceptor';
import { UnauthorizedInterceptor } from './unauthorized-interceptor';

/** Http interceptor providers executed in top-down order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: PortalVersionHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HydraSystemHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorEnhancerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: MockHttpInterceptorService, multi: true },
];

export const UNAUTHENTICATED_HTTP_INTERCEPTORS: InjectionToken<HttpInterceptor[]> = new InjectionToken<
  HttpInterceptor[]
>('UNAUTHENTICATED_HTTP_INTERCEPTORS');

export const unauthenticatedHttpInterceptorProviders = [
  { provide: UNAUTHENTICATED_HTTP_INTERCEPTORS, useClass: PortalVersionHttpInterceptor, multi: true },
  { provide: UNAUTHENTICATED_HTTP_INTERCEPTORS, useClass: HydraSystemHttpInterceptor, multi: true },
  { provide: UNAUTHENTICATED_HTTP_INTERCEPTORS, useClass: HttpErrorEnhancerInterceptor, multi: true },
  { provide: UNAUTHENTICATED_HTTP_INTERCEPTORS, useClass: MockHttpInterceptorService, multi: true },
];
